// import wx from 'wx';
import Fly from 'flyio'
// import router from '../router/index'
import wx from './wx'
import {delCookie} from './index'
// import {getCookie} from './index';

const fly = new Fly() // 创建fly实例

// fly 默认设置部分
fly.config.baseURL = 'https://api.ruan.net/api'            // BaseUrl
fly.config.withCredentials = true      // 跨域时是否发送cookie
fly.config.timeout = 5000         // timeout时间
fly.config.headers = {             // 设置头部
  'x-identity': 'advertiser'
  // 'Authorization': `Bearer ${getCookie('token')}`
}

// 添加请求拦截器
fly.interceptors.request.use((request) => {
  // 给所有请求添加自定义header
  // request.headers['X-Tag'] = 'flyio';

  // 判断用户是否有token
  // if (getCookie('token')) {
  //
  // } else {
  //   window.location = '/login';
  //   // wx.redirectTo({url: '/pages/login/login'});
  // }

  // wx.showLoading();

  // 终止请求
  // var err=new Error("xxx")
  // err.request=request
  // return Promise.reject(new Error(""))

  // 可以显式返回request, 也可以不返回，没有返回值时拦截器中默认返回request
  return request
})

// 添加响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use(
  (response) => {
    const res = response.data

    // wx.hideLoading();

    if (!res.success) {
      // Message({
      //   message: res.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  (error) => {
    // 发生网络错误后会走到这里
    wx.hideLoading()
    // console.log('err' + error.status); // for debug
    // Message({
    //   message: error.response.data.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })

    // 401 未知的用户凭证
    if (error.status === 401) {
      delCookie('token')
      // router.push('/login')
    }
    return Promise.reject(error.response.data)
  }
)

export default fly



// WEBPACK FOOTER //
// ./src/utils/request.js